"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParamParsers_1 = require("../../core/utils/ParamParsers");

var index_1 = require("../../index");

var StoreSpecificationEnum_1 = require("../../promotion/model/StoreSpecificationEnum");

var WindowFilter_1 = require("../model/WindowFilter");

var WindowStateEnum_1 = require("../model/WindowStateEnum");

var WindowFilterConverter_1 = require("./WindowFilterConverter");

var WindowFilterConverterImpl =
/*#__PURE__*/
function (_WindowFilterConverte) {
  _inherits(WindowFilterConverterImpl, _WindowFilterConverte);

  function WindowFilterConverterImpl() {
    _classCallCheck(this, WindowFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowFilterConverterImpl).apply(this, arguments));
  }

  _createClass(WindowFilterConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var states = ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'windowWFState', WindowStateEnum_1.WindowStateEnum);
      var excludedStates = ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'excludedStates', WindowStateEnum_1.WindowStateEnum);
      var storeSpecifications = ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'storeSpecifications', StoreSpecificationEnum_1.StoreSpecificationEnum);
      var promotionWFState = ParamParsers_1.ParamParsers.parseListOfEnumValues(source, 'promotionWFState', index_1.PromotionStateEnum);
      return new WindowFilter_1.WindowFilter(WindowFilter_1.WindowFilter.schema.limit.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.offset.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.ids.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.themeId.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.promotionId.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.simulationId.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.windowTypeIds.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.promotionTypeIds.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.years.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.weeks.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.select.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.filter.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.promotionIds.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.promotionWeekType.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.themeIds.valueOfField(source) || undefined, undefined, excludedStates || undefined, WindowFilter_1.WindowFilter.schema.simulationsOnly.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.stateFlags.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.portfolios.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.dummy.valueOfField(source) || undefined, WindowFilter_1.WindowFilter.schema.dummyOriginId.valueOfField(source) || undefined, storeSpecifications || undefined, promotionWFState || undefined, states || undefined);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        limit: source.limit,
        offset: source.offset,
        ids: source.ids,
        themeId: source.themeId,
        promotionId: source.promotionId,
        simulationId: source.simulationId,
        windowTypeIds: source.windowTypeIds,
        promotionTypeIds: source.promotionTypeIds,
        years: source.years,
        weeks: source.weeks,
        select: source.select,
        filter: source.filter,
        promotionIds: source.promotionIds,
        promotionWeekType: source.promotionWeekType,
        themeIds: source.themeIds,
        windowWFState: source.windowWFState,
        excludedStates: source.excludedStates,
        simulationsOnly: source.simulationsOnly,
        stateFlags: source.stateFlags,
        portfolios: source.portfolios,
        dummy: source.dummy,
        dummyOriginId: source.dummyOriginId,
        storeSpecifications: source.storeSpecifications,
        promotionWFState: source.promotionWFState
      });
      return result;
    }
  }]);

  return WindowFilterConverterImpl;
}(WindowFilterConverter_1.WindowFilterConverter);

exports.WindowFilterConverterImpl = WindowFilterConverterImpl;